/**Модель описывает файл из импортируемой задачи */
export class TaskImportFileModel {
  /**Название */
  Name: string;
  /**Ссылка */
  Url: string;
  /**Размер */
  Size: number;

  constructor(obj?: Partial<TaskImportFileModel>) {
    Object.assign(this, obj);
  }
}
